import script from "./ClientProjectHisDataYToX.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectHisDataYToX.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectHisDataYToX.vue?vue&type=style&index=0&id=921dceb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-921dceb0"]])

export default __exports__